$(document).ready(function() {

  
  // initial variables
  var selectedProdduct = {};
  var mealTotalCount = 0;
  var coockieMealCount = 0;
  
  // onload functions
  checkMealCount();
  prepareSelectedItem();
  
  function prepareSelectedItem() {
    var meal_product = getCookie('meal_product1');
    if(meal_product != null && meal_product != '') {
      selectedProdduct = JSON.parse(getCookie('meal_product1'));

      if(Object.keys(selectedProdduct).length > 0) {
        for (var key in selectedProdduct) {
          if (selectedProdduct.hasOwnProperty(key) && selectedProdduct[key] > 0) {
            $(`.prd-items[data-closest][data-handle="${key}"]`).addClass('item-selected');
            $(`.prd-items[data-closest][data-handle="${key}"] .prd---btn`).hide();
            $(`.prd-items[data-closest][data-handle="${key}"] .c-product__button`).show();
            $(`.prd-items[data-closest][data-handle="${key}"] .c-product__button [data-qty]`).html(selectedProdduct[key]);
          }
        }
        appendHTML();
      }
    }
  }
  
  function checkMealCount() {
  	var mealCount = getCookie('meal_count1');
    if(mealCount != null && mealCount !== undefined && mealCount != "") {
    	$('[data-cookie-total]').html(mealCount);
      	coockieMealCount = mealCount;
    	$('[data-remain-qty]').text(coockieMealCount);
    }
  }
  
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  if (window.location.href.indexOf('#meals') > -1) {
    $('[data-step="2"]').show();
    $('[data-step-next]').removeClass('active');
    $('[data-step-next="2"]').addClass('active');
  } else if(window.location.href.indexOf('#add-ons') > -1) {
    $('[data-step="4"]').show();
  } else if(window.location.href.indexOf('#review') > -1) {
    $('[data-step="3"]').show();
  } else {
    $('[data-step="1"]').show();
  }

  $('body').on('click', '[data-step-next]', function() {
	var step = $(this).attr('data-step-next');
    $('[data-step]').hide();
    $('[data-step-next]').removeClass('active');
    $('[data-step="'+step+'"]').show();
//     $('[data-step-next="'+step+'"]').addClass('active');
    $(this).addClass("active");
    if(step == "2" && $(this).hasClass('c-btn')) {
      var mealCount = $(this).attr('data-meal-count');
 coockieMealCount = getCookie('meal_count1');
      $('[data-cookie-total]').html(mealCount);
      setCookie('meal_count1', mealCount, 356);
      $('[data-step-next="2"]').removeAttr('style');
      if(parseInt(coockieMealCount) > parseInt(mealCount)) {
      	setCookie('meal_product1', '', -1);
        $('[data-qty]').text(1);
        $('[data-closest]').removeClass('item-selected');
        $('.c-product__button').hide();
        $('.prd---cart .prd---btn').show();
        $('[data-item-remove]').click();
      }
     appendHTML();
    }
  });
  
  $('body').on('click', '[data-switch-col]', function() {
	var coll = $(this).attr('data-click');
    
    $('.filter-item button').removeClass('coll-active');
    $(this).addClass('coll-active');
    
    if(coll == 'all-meals') {
      $('[data-collection]').show();
      $('[data-show]').hide();
      $('[data-show]:first').show();
    } else {
      $('[data-collection], [data-show]').hide();
      $('[data-collection="'+coll+'"], [data-show="'+coll+'"]').show();
    }
  });
  
  $('body').on('click', '[data-add-product]', function() {
     var checkR=checkRemain();
    if(checkR > 0 ){
      $(this).closest('.prd---btn').hide();
      var plan_id ;
      var meal_p=$(".c-plan-button .c-btn.active").data("meal-count");
      if(meal_p == "5"){
      console.log("valplan 5",$(this).data("plan-five"));
        plan_id=$(this).data("plan-five");
      }else if(meal_p == "10"){
              console.log("valplan 10",$(this).data("plan-ten"));
        plan_id=$(this).data("plan-ten");
      }else if(meal_p == "15"){
        plan_id=$(this).data("plan-fifty");
      console.log("valplan 15",$(this).data("plan-fifty"));
      }
      $(this).closest('.prd---cart').find('.c-product__button').show();
      $(this).closest('[data-closest]').addClass('item-selected');
      var pr_handle = $(this).closest('[data-handle]').attr('data-handle') ;
      selectedProdduct[pr_handle] = 1;
      setCookie('meal_product1', JSON.stringify(selectedProdduct), 356);
      appendHTML();
    }
  });
  
  $('body').on('click', '[data-plus]', function() {
     var checkR=checkRemain();
    if(checkR > 0 ){
    var newQty = parseInt($(this).closest('[data-qty-wrap]').find('[data-qty]').text())+1;
    $(this).closest('[data-qty-wrap]').find('[data-qty]').text(newQty);
    let handle = $(this).closest('[data-handle]').attr('data-handle');
    $('[data-handle="'+handle+'"][data-qty-wrap-in]').find('[data-qty]').text(parseInt($(this).closest('[data-qty-wrap]').find('[data-qty]').text())+1);
    selectedProdduct[handle] = newQty;
    setCookie('meal_product1', JSON.stringify(selectedProdduct), 356);
    appendHTML();
    }
  });
  
  $('body').on('click', '[data-minus]', function() {
    var handle = $(this).closest('[data-handle]').attr('data-handle');
    if (parseInt($(this).closest('[data-qty-wrap]').find('[data-qty]').text()) === 1) {
      $(this).closest('.prd---cart').find('.prd---btn').show();
      $(this).closest('.prd---cart').find('.c-product__button').hide();
      $('[data-same="'+handle+'"]').remove();
      $('.item-selected[data-handle="'+handle+'"][data-closest]').removeClass('item-selected');
      selectedProdduct[handle] = 0;
    } else {
      $(this).closest('[data-qty-wrap]').find('[data-qty]').text(parseInt($(this).closest('[data-qty-wrap]').find('[data-qty]').text())-1); 
      $('[data-handle="'+handle+'"][data-qty-wrap-in]').find('[data-qty]').text(parseInt($(this).closest('[data-qty-wrap]').find('[data-qty]').text())-1);
      selectedProdduct[handle] = parseInt($(this).closest('[data-qty-wrap]').find('[data-qty]').text())-1;
    }
    setCookie('meal_product1', JSON.stringify(selectedProdduct), 356);
    appendHTML();
  });
  
  function countTotal() {
    coockieMealCount = getCookie('meal_count1');
    let count = 0;
    $('[data-items] [data-same]').each(function() {
      count += parseInt($(this).find('[data-qty-in]').text());
    });
    mealTotalCount = count;
    $('[data-items-count]').text(mealTotalCount);
    var remainQty = coockieMealCount - mealTotalCount;
   
    if(remainQty == 0) {
    	$('[data-addon-step]').removeAttr('disabled');
      $('[data-addon-step]').html("Continue to Review");
        $('[data-step-next="3"]').removeAttr('style');
      	$('.subscription-prd-list').addClass('limit-exceed');
      
    } else {
    	$('[data-addon-step]').attr('disabled','disabled');
      	$('.subscription-prd-list').removeClass('limit-exceed');
      $('[data-addon-step]').html("<span>Add <span data-remain-qty>0</span> More Meals to Continue</span>");
      $('[data-step-next="3"]').attr('style', 'pointer-events: none');
    }
     $('[data-remain-qty]').text(remainQty);
  }
  
  $('body').on('click', '[data-minus-in]', function() {
    var handle = $(this).closest('[data-handle]').attr('data-handle');
    if (parseInt($(this).closest('[data-qty-wrap-in]').find('[data-qty-in]').text()) === 1) {
      $('.prd-items[data-handle="'+handle+'"]').find('.prd---cart .prd---btn').show();
      $('.prd-items[data-handle="'+handle+'"]').find('.prd---cart .c-product__button').hide();
      $('[data-same="'+handle+'"]').remove();
      $('.item-selected[data-handle="'+handle+'"][data-closest]').removeClass('item-selected');
      selectedProdduct[handle] = 0;
    } else {
      $(this).closest('[data-qty-wrap-in]').find('[data-qty-in]').text(parseInt($(this).closest('[data-qty-wrap-in]').find('[data-qty-in]').text())-1); 
      $('[data-qty-wrap="'+handle+'"]').find('[data-qty]').text(parseInt($('[data-qty-wrap="'+handle+'"]').find('[data-qty]').text())-1);
      selectedProdduct[handle] = parseInt($('[data-qty-wrap="'+handle+'"]').find('[data-qty]').text())-1;
    }
    setCookie('meal_product1', JSON.stringify(selectedProdduct), 356);
    appendHTML();
  });
  
  $('body').on('click', '[data-plus-in]', function() {
    let handle = $(this).closest('[data-handle]').attr('data-handle');
    var checkR=checkRemain();
    if(checkR > 0 ){
    var newQty = parseInt($(this).closest('[data-qty-wrap-in]').find('[data-qty-in]').text())+1;
    $('[data-handle="'+handle+'"][data-qty-wrap-in]').find('[data-qty]').text(newQty);
    $('.prd-items[data-handle="'+handle+'"]').find('[data-qty]').text(parseInt($(this).closest('[data-qty-wrap-in]').find('[data-qty-in]').text())+1);
    selectedProdduct[handle] = newQty;
    setCookie('meal_product1', JSON.stringify(selectedProdduct), 356);
    appendHTML();
    }
  });
  function checkRemain(){
  coockieMealCount = getCookie('meal_count1');
    let count = 0;
    $('[data-items] [data-same]').each(function() {
      count += parseInt($(this).find('[data-qty-in]').text());
    });
    mealTotalCount = count;
    $('[data-items-count]').text(mealTotalCount);
    var remainQty = coockieMealCount - mealTotalCount;
    return remainQty;
  }
  $('body').on('click', '[data-item-remove]', function() {
    let handle = $(this).closest('[data-same]').attr('data-same');
    selectedProdduct[handle] = 0;
    setCookie('meal_product1', JSON.stringify(selectedProdduct), 356);
    $('.prd-items[data-handle="'+handle+'"]').find('.prd---cart .prd---btn').show();
    $('.prd-items[data-handle="'+handle+'"]').find('.prd---cart .c-product__button').hide();
    $('.item-selected[data-handle="'+handle+'"][data-closest]').removeClass('item-selected');
    appendHTML();
  });
  
  function appendHTML() {
    var html = '';
    
    $('.item-selected').each(function() {
      let $target = $(this);
      html += `<div class="b--item" data-same="${$target.closest('[data-handle]').attr('data-handle')}">
                      <div class="b--item-grid">
                        <div class="item-img">
                          <img src="${$target.find('[data-img]').attr('src')}" width="300">
                        </div>
                        <div class="b--item-details">
                          <div class="dtails-grid">
                            <div class="inner-drtails">
                              <span class="inner-prd-tag">${$target.find('[data-col]').text()}</span>
                              <h1>${$target.find('[data-title]').text()}</h1>
								<button class="item-remove" data-item-remove>Remove</button>
                            </div>
                            <div class="s-controll">
                              <ul class="s-controll-div" data-qty-wrap-in data-handle="${$target.closest('[data-handle]').attr('data-handle')}">
                                <li class="s-c-list">
                                  <button class="c-qty-btn" data-minus-in>–</button>
                                </li>
                                <li class="s-c-list">
                                  <button class="c-qty-text" data-qty-in> ${$target.find('[data-qty]').text()} </button>
                                </li>
                                <li class="s-c-list">
                                  <button class="c-qty-btn" data-plus-in>+</button>
                                </li>
                              </ul>
                            </div>
                          </div>

                        </div>

                      </div>
                    </div>`;
    });
    
    $('.cart-basket').find('[data-items]').html(html);
    countTotal();
    prePareReviewTab();
  }
  
  function prePareReviewTab(){
    var html = '';
    var c=0;
    $('.item-selected').each(function() {
      let $target = $(this);
	  c=c+parseInt($target.find('[data-qty]').text());      
      html += `<div class="b--items">
          <div class="b--item">
            <div class="b--item-grid">
              <div class="item-img">
                <img src="${$target.find('[data-img]').attr('src')}">
              </div>
              <div class="b--item-details">
                <div class="dtails-grid">
                  <div class="inner-drtails">
                    <span class="inner-prd-tag">${$target.find('[data-col]').text()}</span>
                    <h1>${$target.find('[data-title]').text()}</h1>
                    <button class="plans-tag">Every Week</button>
                  </div>
                  <div class="s-controll">
                    <span class="item-number">${$target.find('[data-qty]').text()}</span>
                  </div>
                </div>

              </div>

            </div>
          </div>

        </div>`;
    });
    $('.s-review').find('[data-items-review]').html(html);
    $(".c-reviewGrid__count").html(c+ " Items");
  }
  
  $('body').on('click', '[data-checkout-btn]', function() {
    var pItems = [];
    var meal_count=parseInt(getCookie("meal_count1"));
    var meal_product = getCookie('meal_product1');
    if(meal_product != null && meal_product != '') {
      var finalProducts = JSON.parse(getCookie('meal_product1'));
        console.log(finalProducts);
//       var pJson = {};
//       if($(".c-plan-button").data("meal-count") == "5"){
//       pJson['selling_plan']=parseInt($("subscription-cart").data("plan-five"));
//       }else if($(".c-plan-button").data("meal-count") == "10"){
//       pJson['selling_plan']=parseInt($("subscription-cart").data("plan-ten"));
//       }
//       else if($(".c-plan-button").data("meal-count") == "15"){
//       pJson['selling_plan']=parseInt($("subscription-cart").data("plan-fifty"));
//       }
      
     
//       pJson['id'] = parseInt($(`[data-meal-count="fin"]`).attr('data-prid'));
//       pJson['quantity'] = 1;
//       pJson['selling_plan'] = parseInt($(`[data-meal-count="${coockieMealCount}"]`).attr('data-product-subscription'));

      if(Object.keys(finalProducts).length > 0) {
        var properties = {};
        var count = 1;  
    
        for (var key in finalProducts) { 
          var pJson = {};
          if (finalProducts.hasOwnProperty(key) && finalProducts[key] > 0) {
         
      if(meal_count == 5){
      pJson['selling_plan']=parseInt($(".subscription-cart").data("plan-five"));
      }else if(meal_count == 10){
      pJson['selling_plan']=parseInt($(".subscription-cart").data("plan-ten"));
      }
      else if(meal_count == 15){
      pJson['selling_plan']=parseInt($(".subscription-cart").data("plan-fifty"));
      }
            var qty = finalProducts[key];
                      console.log("key",key);

            pJson['id']=parseInt($("[data-prd-handle="+key+"]").data("prd-id"));
            pJson['quantity'] = parseInt($("[data-prd-handle="+key+"]").html());
            
            console.log("key",pJson['id']);

            pItems = [...pItems, pJson];
          }
        }
      }
//       pJson['properties'] = properties;
     
    }
    console.log(pItems);
    var formData = { 'items': pItems };
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
          console.table(data);
        console.log(data);
          window.location.href = "/checkout";
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    })
  });
});  
